// Copy-to-clipboard for discount codes in the seasonal promo strip (sections/event-promo-strip.liquid).
(() => {
  if (window.eventPromoStripReady) return;
  window.eventPromoStripReady = true;

  const RESET_DELAY = 2000;

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('Copy command was rejected');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;

    const { copyCode, copyLabel, copiedLabel } = button.dataset;
    const label = button.querySelector('[data-copy-label]');
    const status = button.closest('[data-event-promo]')?.querySelector('[data-copy-status]');

    try {
      await copyText(copyCode);
      if (label) label.textContent = copiedLabel;
      if (status) status.textContent = `${copiedLabel} ${copyCode}`;
    } catch (error) {
      // Clipboard blocked: select the code so it can be copied manually.
      const code = button.closest('.event-promo-code')?.querySelector('code');
      if (code) window.getSelection().selectAllChildren(code);
    }

    clearTimeout(button.resetTimer);
    button.resetTimer = setTimeout(() => {
      if (label) label.textContent = copyLabel;
      if (status) status.textContent = '';
    }, RESET_DELAY);
  });
})();
